import React, { ReactNode } from 'react';
import { PartialSearchingProps, SearchingProps } from 'modules/Shared/type';
import { PageProps } from 'modules/Layout/type';
import { managePageAction, ManagePageAction } from 'modules/Layout/action';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Listing from 'modules/Layout/component/Listing';
import { createSearchingProps } from 'modules/Shared/helper/params';
import {
  setSensorSoftwareListParamsAction,
  SetSensorSoftwareListParamsAction
} from 'modules/Sensor/action/list';
import SensorSoftware from 'modules/Sensor/model/SensorSoftware';
import SensorSoftwareTable from 'modules/Sensor/container/Table';
import SensorSoftwareFilter from 'modules/Sensor/container/Filter';
import SensorSoftwarePagination from 'modules/Sensor/container/Pagination';
import SensorSoftwarePerPage from 'modules/Sensor/container/PerPage';
import { breadcrumbRouteSensorSoftwares } from 'modules/Sensor/breadcrumbs';
import { RootState } from 'app/reducer';

export interface StateProps {
  fetching: boolean;
}

export interface DispatchProps {
  managePage: (payload: PageProps) => ManagePageAction;
  setParams: (
    payload: PartialSearchingProps
  ) => SetSensorSoftwareListParamsAction;
}

export type Props = StateProps & DispatchProps;

export const mapDispatch = (dispatch: Dispatch): DispatchProps => ({
  managePage: (payload: PageProps) => dispatch(managePageAction(payload)),
  setParams: (payload: PartialSearchingProps) =>
    dispatch(setSensorSoftwareListParamsAction(payload))
});

export const mapState = (state: RootState): StateProps => {
  const { fetching } = state.sensor.sensorSoftwareList;

  return { fetching };
};

export class SensorSoftwaresListView extends React.Component<Props> {
  protected searchProps: SearchingProps;

  constructor(props: Props) {
    super(props);

    this.searchProps = createSearchingProps(
      window.location.hash,
      SensorSoftware.getFilterableAttributes(),
      SensorSoftware.getSortableAttributes()
    );
  }

  componentDidMount(): void {
    const { managePage, setParams } = this.props;

    managePage({
      title: 'Sensor software',
      breadcrumb: breadcrumbRouteSensorSoftwares()
    });

    setParams(this.searchProps);
  }

  render(): ReactNode {
    const { fetching } = this.props;
    const { filter } = this.searchProps;

    return (
      <div className="row sensor-softwares-view">
        <div className="col-12">
          <Listing
            table={<SensorSoftwareTable />}
            filter={<SensorSoftwareFilter values={filter} />}
            pagination={<SensorSoftwarePagination />}
            perPage={<SensorSoftwarePerPage />}
            loading={fetching}
          />
        </div>
      </div>
    );
  }
}

export default connect<StateProps, DispatchProps>(
  mapState,
  mapDispatch
)(SensorSoftwaresListView);
